/**
 * Question Backend CDK - REST API クライアント（受講者向け）
 *
 * CDK でデプロイされたリアルタイムバックエンドの設定を管理する。
 * WebSocket接続とREST API接続に必要な設定を提供する。
 */

import { getCachedFrontendSettings } from './frontendSettings';

// =============================================================================
// 型定義
// =============================================================================

export interface QuestionBackendConfig {
  realtimeEndpoint: string;
  httpEndpoint: string;
  apiKey: string;
  restApiUrl: string;
}

// =============================================================================
// 設定取得
// =============================================================================

/**
 * テスト問題バックエンドの設定を取得（frontend-settings APIのキャッシュを参照）
 *
 * 呼び出し前に ensureFrontendSettings() で設定を取得しておくこと。
 */
export function getQuestionBackendConfig(): QuestionBackendConfig {
  const settings = getCachedFrontendSettings();
  return {
    realtimeEndpoint: settings?.questionRealtimeEndpoint || '',
    httpEndpoint: settings?.questionHttpEndpoint || '',
    apiKey: settings?.questionApiKey || '',
    restApiUrl: settings?.questionRestApiUrl || '',
  };
}

/**
 * Question Backend CDK が利用可能か判定する。
 */
export function isQuestionBackendAvailable(): boolean {
  const config = getQuestionBackendConfig();
  return !!(config.realtimeEndpoint && config.httpEndpoint && config.apiKey);
}
